/**
 * @file Re-exports SelectFolderButton as the entry point of the module.
 */
import SelectFolderButton from "./SelectFolderButton";

export default SelectFolderButton;
